export const TODAY = "today";
export const LAST_24_HOURS = "last_24_hours";

export const THIS_WEEK = "this_week";
export const LAST_7_DAYS = "last_7_days";

export const THIS_MONTH = "this_month";
export const LAST_30_DAYS = "last_30_days";

export const THIS_YEAR = "this_year";
export const LAST_12_MONTHS = "last_12_months";

export const RANGE = "range";
